import Config from '../../utils/Config';

class ProjectVideo extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            playing : false,
            uuid    : uuid()
        };

        this.onScroll = this.onScroll.bind(this);
    }

    componentDidMount() {
        $('.project').on('scroll', this.onScroll);
    }

    componentWillUnmount() {
        $('.project').off('scroll', this.onScroll)
    }

    onScroll() {
        var self = this;

        var h           = $(window).height();
        var offset      = $('#'+this.state.uuid).offset().top;

        if (this.state.playing)
            return;

        if (offset < h - 500) {

            this.setState({ playing : true } , function() {

                $('#'+this.state.uuid).css({ 'opacity' : 1 });

                var video = document.getElementById('vid_'+this.state.uuid);

                video.play();
            });
        }
    }

    render() {
        var project = this.props.project;

        return (
            <div
                className='project-video'
                id={this.state.uuid}>

                <video
                    id={'vid_'+this.state.uuid}
                    width='320'
                    height='240'
                    loop>

                    <source
                        src={Config.imgUrl()+'/public/codi-studios/video/'+this.props.id+'/'+project.name+'.m4v'}
                        type='video/mp4; codecs=avc1.42E01E,mp4a.40.2' />

                    <source src='pr6.webm' type='video/webm; codecs=vp8,vorbis' />
                </video>

            </div>
        );
    }
}

export default ProjectVideo;


                    // <source src='pr6.ogv'  type='video/ogg; codecs=theora,vorbis' />



// WEBPACK FOOTER //
// ./ui_src/app/components/portfolio/ProjectVideo.react.jsx